module.exports = __webpack_public_path__ + "media/images/brands/dropbox-e759033031a7a7cc4bba46ea8b5b0054.png";